import { render, staticRenderFns } from "./GreenEvaluation.vue?vue&type=template&id=5dd56dba&scoped=true&"
import script from "./GreenEvaluation.vue?vue&type=script&lang=js&"
export * from "./GreenEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./GreenEvaluation.vue?vue&type=style&index=0&id=5dd56dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd56dba",
  null
  
)

export default component.exports